module.exports = __webpack_public_path__ + "static/media/Puntu-Icon-Lupa.27002450.png";